import React from 'react';

const MedicProfile = ({medic, isWrapped = false}) => {
  if (!medic) return null;
  
  const renderContent = () => {
    return (
      <div className="kt-profile__main" style={isWrapped ? {borderRight: 0} : null}>
        <div
          className="kt-profile__main-pic medicloud-user-profile-avatar"
          style={{backgroundImage: `url(${medic.full_profile_image})`}}
        />
        <div className="kt-profile__main-info">
          <div className="kt-profile__main-info-name">
            {medic.prefix_name} {medic.name} {medic.lastname}
          </div>
          <div className="kt-profile__main-info-position">
            {medic.specialty_name}
          </div>
        </div>
      </div>
    )
  }
  
  return (
    isWrapped ?
      <div className="kt-portlet kt-profile">
        <div className="kt-profile__content">
          {renderContent()}
        </div>
      </div>
      : renderContent()
  );
};

export default MedicProfile;
